import { render, staticRenderFns } from "./book-button.vue?vue&type=template&id=223e0cf1"
import script from "./book-button.vue?vue&type=script&lang=js"
export * from "./book-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports